export class NICEDialerXSSettings {
    xsScriptID = 0;
    xsCheckinScriptID = 0;
    // tslint:disable-next-line:variable-name
    xsSkillChangedActive= false;
    xsGetContactsActive=false ;
    xsFreshThreshold = 0;
    xsAvailableThreshold = 0;
    xsReadyThreshold = 0;
    xsNumberToRetrieve = 0;
    externalOutboundSkill_No = '';

    constructor(jsonObject?) {
        if (jsonObject) {
            this.xsScriptID = jsonObject.xsScriptID;
            this.xsCheckinScriptID = jsonObject.xsCheckinScriptID;
            this.xsSkillChangedActive = jsonObject.xsSkillChangedActive;
            this.xsGetContactsActive = jsonObject.xsGetContactsActive;
            this.xsFreshThreshold = jsonObject.xsFreshThreshold;
            this.xsAvailableThreshold = jsonObject.xsAvailableThreshold;
            this.xsReadyThreshold = jsonObject.xsReadyThreshold;
            this.xsNumberToRetrieve = jsonObject.xsNumberToRetrieve;
            this.externalOutboundSkill_No = jsonObject.externalOutboundSkill_No;
        }
    }
}


